export default {
  "content": "<g clip-path=\"url(#icon_bell_filled_svg__a)\"><path fill-rule=\"evenodd\" d=\"M14.26 11.01c-.39-.66-.63-1.4-.72-2.16l-.2-1.81a6.599 6.599 0 00-2.88-4.74L10 2c0-1.1-.9-2-2-2S6 .9 6 2l-.77.51c-1.4.94-2.28 2.48-2.36 4.17l-.1 1.85c-.04.87-.32 1.7-.79 2.41a1.99 1.99 0 00-1.31 1.87V13c0 .55.44 1 1 1H6c0 1.1.9 2 2 2s2-.9 2-2h4.33c.55 0 1-.45 1-1v-.22c0-.76-.42-1.43-1.07-1.77z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"icon_bell_filled_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};